export default function({ $gtm, route }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        originalLocation: document.location.protocol + "//" +
            document.location.hostname +
            document.location.pathname +
            document.location.search
    });
}
